import { LESSON_STATUS } from '@yandex-int/k-common/typings';
import { SimpleCallback, useSocketIO } from 'platform-components';
import { useDispatch, useSelector } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import { actions as lessonActions } from 'common.components/lesson';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { resultsActions } from 'common.components/results/actions';

interface Props {
    onAttemptCreated?: SimpleCallback;
}

// Этот компонент принимает сообщения (emit) от сокетов учеников, решающих занятие
// Обновляет статус по карточкам: попытки, время, на какой находятся ученики
export const LessonSocket = ({ onAttemptCreated }: Props) => {
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const courseId = useSelector(getCurrentYearCourseId);
    const status = useSelector(lessonSelectors.getLessonStatus);
    const dispatch = useDispatch();

    const handleConnect = () => {
        emit('joinLesson', { clessonId, isTeacher: true });
    };

    const handleAttemptCreated = () => {
        if (status === LESSON_STATUS.ASSIGNED && courseId && clessonId) {
            if (onAttemptCreated) {
                onAttemptCreated();
            }
            dispatch(lessonActions.getClessonWithResultsRequest({ courseId, clessonId }));

            dispatch(lessonActions.lessonUpdated());
        }
    };

    const handleInProblem = (args: { studentId: number; problemLinkId: number }) => {
        dispatch(resultsActions.setStudentOnline({ studentId: args.studentId, problemId: args.problemLinkId }));
    };

    const handleLeaveProblem = (args: { studentId: number }) => {
        dispatch(resultsActions.setStudentOnline({ studentId: args.studentId, problemId: null }));
    };

    const { emit } = useSocketIO('/course/lessons', {
        connect: handleConnect,
        attemptCreated: handleAttemptCreated,
        inProblem: handleInProblem,
        leaveProblem: handleLeaveProblem,
    });

    return null;
};
